<div class="p-9">
  <div class="grid grid-cols-1 md:grid-cols-3 gap-4 !p-4">
    <label class="form-label"><span class="required">{{"ACCOUNT_SETTINGS.GENERAL_INFO.ROLE" | translate}}</span></label>
    <div class="col-span-2">
      <input
        pInputText
        [pSize]="'large'"
        [fluid]="true"
        [disabled]="true"
        class="form-control"
        [placeholder]="fullNamePlaceholder"
        type="text"
      />
    </div>
    <label class="form-label">{{"ACCOUNT_SETTINGS.GENERAL_INFO.ACTIVE" | translate}}</label>

    <div class="flex items-center gap-2">
      <label class="form-label !mb-0"> {{"ACCOUNT_SETTINGS.GENERAL_INFO.IS_ACTIVE" | translate}} </label>
      <p-checkbox
        [ngModel]="user().isActive"
        inputId="size_large"
        name="size"
        value="Large"
        size="large"
        [binary]="true"
        [disabled]="true"
      />
    </div>
  </div>
</div>
